import script from "./ADialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ADialog.vue?vue&type=script&lang=ts&setup=true"

import "./ADialog.vue?vue&type=style&index=0&id=65bbea74&lang=scss"
import "./ADialog.vue?vue&type=style&index=1&id=65bbea74&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65bbea74"]])

export default __exports__